<template>
    <div>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form name="formEditarTarjeta" @submit.prevent="submit">
                <v-row :class="$vuetify.breakpoint.mdAndUp ? '' : 'pb-12'">
                    <v-col cols="12" md="12" class="mb-3 pt-0">
                        <div class="font-weight-regular text-subtitle-2 mb-1 grey--text text--darken-1">
                            Titular
                        </div>
                        <div style="border-bottom: 1px solid #aaa;">
                            {{ nomYApe }}
                        </div>
                    </v-col>
                    <v-col cols="12" md="8">
                        <ValidationProvider rules="required|visa_luhn" v-slot="v">
                            <v-text-field v-model="numeroDisplay" label="Número de Tarjeta" :maxlength="19"
                                placeholder="0000 0000 0000 0000" @input="onTarjetaInput" :error-messages="v.errors[0]"
                                @keydown="preventArrowKeys"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="4">
                        <ValidationProvider rules="required|exp_mm_aa" v-slot="v">
                            <v-text-field v-model="tarj.deb_fecvenc" label="Fecha de vencimiento (MM/AA)"
                                placeholder="MM/AA" maxlength="5" @input="onFecVencInput" :error-messages="v.errors[0]"
                                @keydown="preventArrowKeys"></v-text-field>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12" class="my-0">
                        <ValidationProvider rules="required" v-slot="v">
                            <v-autocomplete v-model="selectedBancoId" class="my-1" :items="bancos" readonly
                                :loading="loading" label="Banco emisor" dense :error-messages="v.errors[0]"
                                item-text="nombre" item-value="id">
                                <template v-slot:append v-if="bancoAutocompletado">
                                    <v-icon color="green">mdi-check-circle</v-icon>
                                </template>
                            </v-autocomplete>
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="12" class="d-flex justify-center">
                        <InputButtonArchivo @fileSelected="handleFileSelected" op="tarjetaFrente"
                            label="TARJETA (FRENTE)" />
                    </v-col>
                </v-row>
            </v-form>
        </ValidationObserver>
    </div>
</template>


<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
    name: 'FormEditarTarjeta',
    mounted() {
        this.getBancos();
        this.nomYApe = (this.user.apellido || '') + ', ' + (this.user.nombres || '');
        this.afiliado.nomYApe = this.nomYApe;
    },

    components: {
        ValidationObserver,
        ValidationProvider,
        InputButtonArchivo
    },
    watch: {


        selectedBancoId(newValue) {
            if (newValue) {
                const bancoSeleccionado = this.bancos.find(b => b.id === newValue);

                this.tarj.deb_banco = newValue;
                this.tarj.bco_nombre = bancoSeleccionado ? bancoSeleccionado.nombre : '';

                // Emitir los datos actualizados
                this.$emit('cuentaDataChanged', {
                    deb_tarjeta: this.tarj.deb_tarjeta || '',
                    deb_fecvenc: this.tarj.deb_fecvenc || '',
                    deb_estado: this.tarj.deb_estado || 'PA',
                    deb_banco: newValue,
                    bco_nombre: this.tarj.bco_nombre,
                    deb_titular: this.tarj.deb_titular || '',
                    deb_nombre_tit: this.tarj.deb_nombre_tit || '',
                    afiliadoId: this.tarj.afiliadoId || null
                });

                this.checkFormValidity();
            }
        },

        // Watcher que observa múltiples propiedades
        tarj: {
            handler(newVal) {
                // Validar solo cuando la tarjeta tenga 16 dígitos y la fecha esté completa (MM/AA)
                if (newVal.deb_tarjeta && newVal.deb_tarjeta.length === 16 &&
                    newVal.deb_fecvenc && newVal.deb_fecvenc.length === 5) {
                    this.loading = true;
                    const obj = {
                        tarjeta: newVal.deb_tarjeta,
                        nroafi: this.nroafi,
                        vencimiento: newVal.deb_fecvenc
                    }
                    this.validarTarjeta(obj).then(response => {
                        if (response && response.valida) {
                            // Si la validación retorna un banco_id, autocompletar el campo
                            if (response.banco_id) {
                                // Buscar el banco en la lista de bancos
                                const bancoEncontrado = this.bancos.find(b => b.id === response.banco_id);

                                if (bancoEncontrado) {
                                    // Autocompletar el banco
                                    this.selectedBancoId = bancoEncontrado.id;
                                    this.tarj.deb_banco = bancoEncontrado.id;
                                    this.tarj.bco_nombre = bancoEncontrado.nombre;
                                    this.bancoAutocompletado = true;

                                    // Emitir los datos actualizados
                                    this.$emit('cuentaDataChanged', {
                                        deb_tarjeta: newVal.deb_tarjeta,
                                        deb_fecvenc: newVal.deb_fecvenc,
                                        deb_estado: newVal.deb_estado || 'PA',
                                        deb_banco: bancoEncontrado.id,
                                        bco_nombre: bancoEncontrado.nombre,
                                        deb_titular: newVal.deb_titular,
                                        deb_nombre_tit: newVal.deb_nombre_tit,
                                        afiliadoId: newVal.afiliadoId
                                    });
                                }
                            }
                        } else {
                            // Si la validación falla, limpiar el banco
                            this.selectedBancoId = null;
                            this.tarj.deb_banco = null;
                            this.tarj.bco_nombre = '';
                            this.bancoAutocompletado = false;
                        }
                        this.checkFormValidity();
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            },
            deep: true,
            immediate: false
        }
    },
    data() {
        return {
            afiliado: {
                afi_fecnacim: null,
                afi_fecmat: null,
                afi_fecafil: null,
                afi_fececivil: null,
                afi_fectit: null,
                afi_segfallecdesde: null,
                afi_fecnivdesde: null,
                conteoCbu: '',
                conteoTarj: '',
                nomYApe: '',
                afi_nroafi: '',
                afi_apellido: '',
                afi_nombres: '',

            },
            tarj: {
                deb_tarjeta: '',
                deb_banco: '',
                bco_nombre: '',
                deb_titular: '',
                deb_nombre_tit: '',
                deb_estado: '',
                deb_id: '',
                afiliadoId: null,
                deb_fecvenc: ''

            },
            cbu: [],
            bancoAutocompletado: false,
            selectedBancoId: null,
            loading: false,
            numero: '',
            titular: '',
            fecVencError: '',
            numeroDisplay: '',
            numeroError: '',
            isFormValid: false
        }
    },
    methods: {
        ...mapActions('mediosDePago', ['getBancos', 'validarTarjeta']),


        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },

        handleFileSelected() {
            if (this.comprobante.length == 1) {
                this.formValid = true
            } else {
                this.formValid = false;
            }

            this.$nextTick(() => {
                this.checkFormValidity();
            });
        },

        // Algoritmo Luhn para validar tarjetas
        luhnCheck(cardNumber) {
            if (!cardNumber || cardNumber.length < 13) return false;

            let sum = 0;
            let alternate = false;

            // Procesar desde el final hacia el inicio
            for (let i = cardNumber.length - 1; i >= 0; i--) {
                let n = parseInt(cardNumber[i]);

                if (alternate) {
                    n *= 2;
                    if (n > 9) {
                        n = (n % 10) + 1;
                    }
                }

                sum += n;
                alternate = !alternate;
            }

            return (sum % 10) === 0;
        },
        async checkFormValidity() {
            // Esperar un tick para que Vue actualice el DOM
            await this.$nextTick();

            if (this.$refs.obs) {
                const isValid = await this.$refs.obs.validate();
                const hasFile = this.comprobante && this.comprobante.length > 0;

                this.isFormValid = isValid && hasFile;

                // Emitir el estado al padre
                this.$emit('validityChanged', this.isFormValid);
            }
        },

        // Validar si es tarjeta Visa y aplicar Luhn
        validateVisaCard(cardNumber) {
            if (!cardNumber) return false;

            // Verificar que sea Visa (comienza con 4)
            if (!cardNumber.startsWith('4')) {
                return false;
            }

            // Verificar longitud (Visa: 13, 16 o 19 dígitos)
            if (![13, 16, 19].includes(cardNumber.length)) {
                return false;
            }

            // Aplicar algoritmo Luhn
            return this.luhnCheck(cardNumber);
        },
        onTarjetaInput(val) {
            const digits = (val || '').replace(/\D/g, '').slice(0, 16); // solo dígitos
            // agrupar cada 4
            const formatted = digits.replace(/(.{4})/g, '$1 ').trim();
            this.numeroDisplay = formatted;
            this.tarj.deb_tarjeta = digits; // valor real para enviar

            // Validar tarjeta Visa con algoritmo Luhn
            if (digits.length >= 13) {
                const isValid = this.validateVisaCard(digits);
                this.numeroError = isValid ? '' : 'Número de tarjeta Visa inválida';
            } else {
                this.numeroError = '';
            }
        },
        onFecVencInput(val) {
            // Mantener sólo dígitos y máximo 4 (MMYY)
            const digits = (val || '').replace(/\D/g, '').slice(0, 4);
            let formatted = digits;
            if (digits.length >= 3) {
                formatted = digits.slice(0, 2) + '/' + digits.slice(2);
            }
            this.tarj.deb_fecvenc = formatted;

        },
    },
    computed: {
        ...mapGetters('mediosDePago', ['bancos', 'selectedBancoId', 'aportesActivosAfi', 'tiposMediosPagos', 'entidadBancaria']),
        ...mapGetters('auth', ['user', 'nroafi']),
        ...mapGetters('dataUser', ['comprobante']),
    },

    props: {
        accion: {
            type: String,
            required: true
        },
        tarjeta: {
            type: Object,
            required: false,
            default: () => ({})
        }
    }
}
</script>